export default "__VITE_ASSET__f4c151d8__"